import { default as brokeraGcCwRE6ASMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/broker.vue?macro=true";
import { default as doplnenie_45udajovhsuMM4Q1QVMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie-udajov.vue?macro=true";
import { default as doplneniebeuvlAMdTuMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie.vue?macro=true";
import { default as fotodokumentaciaC7A0ylkKQkMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/fotodokumentacia.vue?macro=true";
import { default as kalkulaciefgwCOmK7SUMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/kalkulacie.vue?macro=true";
import { default as platba7EorgxdltUMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/platba.vue?macro=true";
import { default as ponukyIBTY3wCUeDMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/ponuky.vue?macro=true";
import { default as rekapitulaciaEYzg0SDRUaMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/rekapitulacia.vue?macro=true";
import { default as upsellMGVV0jjIvIMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/upsell.vue?macro=true";
import { default as vyrocieKGVcbfmIQfMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/vyrocie.vue?macro=true";
import { default as zavolajtemiQ79W8fBsJgMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/zavolajtemi.vue?macro=true";
import { default as pageFf6UjBRcCzMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45test8TpoiXVfUEMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepage178KZhskpxMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articlezgqa256KQGMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsEToqXOeeyWMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagc5TY1NxOc1Meta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorrFbnpH1m6WMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryaL0Id1h8SpMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionMCzazDNQ9OMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesdorJB6xSjMMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as category3J3qRuIkxrMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleDGt7trHXuzMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionxF5HPjCdGTMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as poistenie_45zivot_45uniqaXYJh8ddVbCMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/poistenie-zivot-uniqa?macro=true";
import { default as odhlasenie_45z_45mailingu8sjBu4GukBMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/odhlasenie-z-mailingu?macro=true";
import { default as complaintJXg7HJDXgQMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/complaint?macro=true";
import { default as contactuxpFJk85jrMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationRTgoynpOjHMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as zadostFsnGw1Pxn3Meta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankUekz1KBtCHMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnanix7SY11dlDqMeta } from "/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
export default [
  {
    name: "autopoistenie-broker",
    path: "/autopoistenie/broker",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/broker.vue")
  },
  {
    name: "autopoistenie-doplnenie-udajov",
    path: "/autopoistenie/doplnenie-udajov",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie-udajov.vue")
  },
  {
    name: "autopoistenie-doplnenie",
    path: "/autopoistenie/doplnenie",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie.vue")
  },
  {
    name: "autopoistenie-fotodokumentacia",
    path: "/autopoistenie/fotodokumentacia",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/fotodokumentacia.vue")
  },
  {
    name: "autopoistenie-kalkulacie",
    path: "/autopoistenie/kalkulacie",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/kalkulacie.vue")
  },
  {
    name: "autopoistenie-platba",
    path: "/autopoistenie/platba",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/platba.vue")
  },
  {
    name: "autopoistenie-ponuky",
    path: "/autopoistenie/ponuky",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/ponuky.vue")
  },
  {
    name: "autopoistenie-rekapitulacia",
    path: "/autopoistenie/rekapitulacia",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/rekapitulacia.vue")
  },
  {
    name: "autopoistenie-upsell",
    path: "/autopoistenie/upsell",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/upsell.vue")
  },
  {
    name: "autopoistenie-vyrocie",
    path: "/autopoistenie/vyrocie",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/vyrocie.vue")
  },
  {
    name: "autopoistenie-zavolajtemi",
    path: "/autopoistenie/zavolajtemi",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/zavolajtemi.vue")
  },
  {
    name: pageFf6UjBRcCzMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45test8TpoiXVfUEMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepage178KZhskpxMeta?.name,
    path: "/magazin",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articlezgqa256KQGMeta?.name,
    path: "/magazin/:article(.*)*",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsEToqXOeeyWMeta?.name,
    path: "/magazin/vzory-dokumentov",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagc5TY1NxOc1Meta?.name,
    path: "/magazin/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorrFbnpH1m6WMeta?.name,
    path: "/magazin/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryaL0Id1h8SpMeta?.name,
    path: "/magazin/:category(poistenie|financie)",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionMCzazDNQ9OMeta?.name,
    path: "/magazin/:category(poistenie|financie)/:section(cestovanie|zivot|dom-a-domacnost|auto|pozicky-a-uvery)",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesdorJB6xSjMMeta?.name,
    path: "/magazin/all-articles",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageFf6UjBRcCzMeta?.name,
    path: "/slovnik-pojmov",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: category3J3qRuIkxrMeta?.name,
    path: "/slovnik-pojmov/:category(poistenie)",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleDGt7trHXuzMeta?.name,
    path: "/slovnik-pojmov/:category(poistenie)/:id(.*)*",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionxF5HPjCdGTMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionxF5HPjCdGTMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: poistenie_45zivot_45uniqaXYJh8ddVbCMeta?.name,
    path: "/poistenie-zivot-uniqa",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/poistenie-zivot-uniqa")
  },
  {
    name: odhlasenie_45z_45mailingu8sjBu4GukBMeta?.name,
    path: "/odhlasenie-z-mailingu",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/odhlasenie-z-mailingu")
  },
  {
    name: complaintJXg7HJDXgQMeta?.name,
    path: "/reklamacie",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/complaint")
  },
  {
    name: contactuxpFJk85jrMeta?.name,
    path: "/kontakty",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationRTgoynpOjHMeta?.name,
    path: "/poistenie/zmena-poistovne-autopoistenie",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: zadostFsnGw1Pxn3Meta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka)/zadost",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankUekz1KBtCHMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnanix7SY11dlDqMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src2610619816/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  }
]